export default __webpack_public_path__ + "static/media/hero-bcg.72249d4a.jpeg";